













import Vue from 'vue'
import { IconChecklistElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'IconChecklist',

  props: {
    templateItemData: {
      type: Object as () => IconChecklistElInterface,
      required: true
    }
  }
})
